import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import SubscriptionPage from './pages/SubscriptionPage';
// import PaymentPage from './pages/PaymentPage'; // Deshabilitado - no necesario ahora
import SuccessPage from './pages/SuccessPage';
import ErrorPage from './pages/ErrorPage';
// import WelcomePage from './pages/WelcomePage'; // Deshabilitado - no necesario ahora

const theme = createTheme({
  palette: {
    primary: {
      main: '#f1c232',
      contrastText: '#000',
    },
    secondary: {
      main: '#ff9800',
    },
    success: {
      main: '#4caf50',
    },
    error: {
      main: '#f44336',
    },
  },
  typography: {
    fontFamily: [
      'Roboto',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 700,
    },
    h3: {
      fontWeight: 700,
    },
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<SubscriptionPage />} />
          <Route path="/subscribe" element={<SubscriptionPage />} />
          {/* <Route path="/unique-payment" element={<PaymentPage />} /> */} {/* Deshabilitado */}
          <Route path="/success-request" element={<SuccessPage />} />
          {/* <Route path="/welcome" element={<WelcomePage />} /> */} {/* Deshabilitado */}
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/error" element={<ErrorPage />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;

